(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var roots = document.currentScript ? [document.currentScript.closest('.bo-buy')] : [];
    document.querySelectorAll('.bo-buy').forEach(function (root) {
      var select = root.querySelector('.bo-select');
      var price = root.querySelector('.bo-price b');
      if (select && price) {
        select.addEventListener('change', function () {
          var opt = select.options[select.selectedIndex];
          if (opt && opt.dataset.price) price.textContent = opt.dataset.price;
        });
      }
      root.querySelectorAll('.bo-qty__btn').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var input = root.querySelector('.bo-qty__in');
          if (!input) return;
          var v = parseInt(input.value, 10) || 1;
          v += parseInt(btn.dataset.step, 10);
          if (v < 1) v = 1;
          input.value = v;
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
